<template>
	<BaseLayout :vertically-centered="true" :footer-full="true">
		<main class="container text-align-center">
			<div class="grid-md gutters-300-md">
				<div class="col-8-md col-offset-2-md col-6-lg col-offset-3-lg">
					<h1 class="heading-1 mb-100 mb-200-md">Forbidden</h1>
					<div class="module">
						<div class="module-section">
							<p>
								You do not have permission to access this page. If you believe this is an error, contact
								us at&nbsp;<BaseLink :link="{ href: 'mailto:support@fundrise.com' }"
									>support@fundrise.com</BaseLink
								>.
							</p>
						</div>
						<div class="module-section">
							<BaseLink class="button button-outline" :link="returnToHomeLink" />
						</div>
					</div>
				</div>
			</div>
		</main>
	</BaseLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Link } from 'types/layout';
import { useAppStore } from '@stores/app';
import { useHead } from '@unhead/vue';

const appStore = useAppStore();

const returnToHomeLink = computed((): Link => {
	const investorRouteName = appStore.isAuthenticated ? 'account-overview' : 'home';
	const router = appStore.isAdvisor ? 'advisor-dashboard' : investorRouteName;

	return {
		router,
		text: 'Back to home'
	};
});

function setup(): void {
	useHead({
		title: 'Forbidden'
	});
}
setup();
</script>
